import { wsClient, WsRecvType, IWsHandler } from '../client'
import { appRef } from '../../app'

type IAuthResultData = boolean

type IAuthResultHandler = IWsHandler<IAuthResultData>

export default function () {
    wsClient.submitHandler(WsRecvType.AuthResult, (({ data }) => {
        if (data) {
            console.log(`%c[WsClient] Authenticated`, 'color: blue')
        } else {
            console.log(`%c[WsClient] Authentication failed`, 'color: red')
            appRef.logout()
        }
    }) as IAuthResultHandler)
}
